import React from 'react';
import { Quote, Star } from 'lucide-react';
import { TESTIMONIALS, AGENT } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const Testimonials = () => {
  return (
    <section
      data-testid={LANDING.testimonials}
      className="bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="bayleys-divider mb-6" />
            <p className="text-xs tracking-[0.3em] uppercase text-bayleys-navy/70 font-medium mb-5">
              Client Testimonials
            </p>
            <h2 className="text-4xl sm:text-5xl font-bold text-bayleys-navy leading-[1.05] tracking-tight max-w-xl">
              What clients are saying.
            </h2>
          </div>
          <a
            href={AGENT.reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm tracking-wider uppercase text-bayleys-navy border-b border-bayleys-navy/30 hover:border-bayleys-navy pb-1 transition-colors"
          >
            <span>View all {AGENT.reviewCount} reviews</span>
            <Star className="w-4 h-4 fill-bayleys-gold text-bayleys-gold" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.slice(0, 3).map((t, idx) => (
            <article
              key={idx}
              data-testid={LANDING.testimonialCard}
              className="relative bg-bayleys-cream p-8 lg:p-10 flex flex-col group hover:bg-bayleys-stone transition-colors duration-300"
            >
              <Quote
                className="absolute top-6 right-6 w-7 h-7 text-bayleys-navy/15"
                strokeWidth={1.5}
              />
              <div className="flex items-center gap-0.5 mb-5">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-3.5 h-3.5 fill-bayleys-gold text-bayleys-gold"
                  />
                ))}
              </div>
              <p className="text-bayleys-navy/85 text-[15px] leading-relaxed font-normal flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 pt-6 border-t border-bayleys-navy/15">
                <p className="text-sm font-bold text-bayleys-navy">{t.author}</p>
                <p className="text-xs tracking-wider uppercase text-bayleys-navy/60 mt-1">
                  {t.date}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
